// appConstants.js

const SUPPORT_EMAIL = 'support@banxa.com';

const BANXA_URLS = {
  terms: 'https://banxa.com/terms-of-use/',
  privacy: 'https://banxa.com/privacy-and-cookies-policy/',
  biometric: 'https://banxa.com/biometric-privacy-disclosure-and-consent',
	dueDiligence: 'https://banxa.com/risk-summary/',
  stateDisclosures: ' https://banxa.com/wp-content/uploads/2025/10/BNXA-USA-MTL-Inc-_-Website-Licenses-as-of-10.16.2025.pdf',
};

const AXNAB_URLS = {
  terms: 'https://axnab.com/terms-of-use/',
  privacy: 'https://axnab.com/privacy-and-cookies-policy/',
  biometric: 'https://axnab.com/biometric-privacy-disclosure-and-consent',
	dueDiligence: 'https://axnab.com/due-diligence',
  stateDisclosures: 'https://axnab.com/wp-content/uploads/2025/10/BNXA-USA-MTL-Inc-_-Website-Licenses-as-of-10.16.2025.pdf',
};

export default { SUPPORT_EMAIL, BANXA_URLS, AXNAB_URLS };
